export default "__VITE_ASSET__1f679f97__"